import { isValid as isValidCnpj } from '@fnando/cnpj'

export function isValidDanfe(accessKey: unknown): boolean {
  if (typeof accessKey !== 'string') return false

  const digits = accessKey.replace(/\W/g, '')

  if (digits.length !== 44) return false
  if (!isValidCnpj(digits.slice(6, 20))) return false

  const reverseKey = digits
    .substring(0, 43)
    .split('')
    .reverse()
    .join('')

  const multipliers = [2, 3, 4, 5, 6, 7, 8, 9]
  const totalMultipliers = multipliers.length

  let sum = 0
  for (let i = 0; i < reverseKey.length; i++) {
    const multiplier = multipliers[((i % totalMultipliers) + totalMultipliers) % totalMultipliers]
    sum += Number(reverseKey[i]) * multiplier
  }

  const sumMod = sum % 11
  let expectedCheckDigit = 11 - sumMod

  if (sumMod < 2) expectedCheckDigit = 0

  const checkDigit = digits[43]

  return parseInt(checkDigit) === expectedCheckDigit
}

export interface ParsedDanfe {
  cUF: number
  AAMM: string
  CNPJ: string
  mod: number
  serie: number
  nNF: number
  tpEmis: number
  cNF: number
  cDV: number
}

export function parseDanfe(accessKey: string): ParsedDanfe | null {
  if (!isValidDanfe(accessKey)) return null

  const digits = accessKey.replace(/\D/g, '')

  return {
    cUF: parseInt(digits.slice(0, 2)),
    AAMM: digits.slice(2, 6),
    CNPJ: digits.slice(6, 20),
    mod: parseInt(digits.slice(20, 22)),
    serie: parseInt(digits.slice(22, 25)),
    nNF: parseInt(digits.slice(25, 34)),
    tpEmis: parseInt(digits.slice(34, 35)),
    cNF: parseInt(digits.slice(35, 43)),
    cDV: parseInt(digits.slice(43, 44)),
  }
}
